import React, { useEffect, FunctionComponent, useMemo } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailInformationChildProps as Props } from './types';

export const Component: FunctionComponent<Props> = (props) => {
  const shouldRender = useMemo(() => {
    return (props.Title && props.Title !== '') || (props.description && props.description !== '');
  }, [props.Title, props.description]);

  useEffect(() => {
    if (!shouldRender) return;

    const $slick = $('.js-company-information');
    if ($slick.length > 0 && !$slick.hasClass('slick-initialized')) {
      $slick.slick({
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0',
        variableWidth: true,
        autoplay: false,
        responsive: [
          {
            breakpoint: 780,
            settings: {
              arrows: false,
              centerMode: false,
            },
          },
        ],
      });
    }
  }, [shouldRender, props.image1, props.image2]);

  return (
    <Presentation
      {...props}
    />
  );
};
